var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "search-form",
              attrs: {
                inline: true,
                model: _vm.searchForm,
                size: "small",
                "label-width": "64px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公告标题" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      "show-word-limit": "",
                      maxlength: "20",
                    },
                    model: {
                      value: _vm.searchForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "title", $$v)
                      },
                      expression: "searchForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "关键字" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      "show-word-limit": "",
                      maxlength: "30",
                    },
                    model: {
                      value: _vm.searchForm.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "keyword", $$v)
                      },
                      expression: "searchForm.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "分类" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("分"),
                          _c("span", { staticClass: "space" }),
                          _vm._v("类"),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请输入或选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "categoryId", $$v)
                        },
                        expression: "searchForm.categoryId",
                      },
                    },
                    _vm._l(_vm.categoryList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.categoryName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间" } },
                [
                  _c("eldate", {
                    attrs: { dateData: _vm.createdTime },
                    on: {
                      changeData: function ($event) {
                        return _vm.changeData($event, "createdTime")
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发起人" } },
                [
                  _c("el-autocomplete", {
                    staticClass: "inline-input",
                    attrs: {
                      "fetch-suggestions": _vm.userSearch,
                      placeholder: "请输入内容",
                      "trigger-on-focus": false,
                      clearable: "",
                    },
                    on: { select: _vm.handleSelect1 },
                    model: {
                      value: _vm.searchForm.createdByName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "createdByName", $$v)
                      },
                      expression: "searchForm.createdByName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "接收人" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-u",
                      attrs: {
                        placeholder: "请选择接收人员",
                        "collapse-tags": "",
                        size: "medium",
                        multiple: "",
                        "popper-class": "hidden",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.openUserPicker.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.searchForm.receivers,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "receivers", $$v)
                        },
                        expression: "searchForm.receivers",
                      },
                    },
                    _vm._l(_vm.searchForm.receivers, function (user, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: user.name, value: user },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审批状态" } },
                [
                  _vm.dictionaries.notice_approval_status
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请输入或选择",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.searchForm.approvalStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "approvalStatus", $$v)
                            },
                            expression: "searchForm.approvalStatus",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.notice_approval_status,
                          function (items) {
                            return _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公告状态" } },
                [
                  _vm.dictionaries.notice_status
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请输入或选择",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.searchForm.noticeStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "noticeStatus", $$v)
                            },
                            expression: "searchForm.noticeStatus",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.notice_status,
                          function (items) {
                            return _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发布时间" } },
                [
                  _c("eldate", {
                    attrs: { dateData: _vm.publishTime },
                    on: {
                      changeData: function ($event) {
                        return _vm.changeData($event, "publishTime")
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { float: "right", "margin-right": "0px" } },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "s-btn",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "r-btn",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                {
                  staticClass: "title-btn-item",
                  on: {
                    click: function ($event) {
                      return _vm.openDialog()
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: {
                      src: require("@/assets/img/announcement/icon_fenlei.png"),
                    },
                  }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("管理分类")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "title-btn-item",
                  on: {
                    click: function ($event) {
                      return _vm.deliverData()
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: { src: require("@/assets/icon_daochu.png") },
                  }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("导出列表")]),
                ]
              ),
              _c(
                "div",
                { staticClass: "title-btn-item", on: { click: _vm.add } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("新增公告内容")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            staticClass: "left-aligned-table",
            attrs: {
              column: _vm.columns,
              data: _vm.list,
              pagination: "",
              total: _vm.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.pageNo,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("view-employment", { ref: "viewEmployment" }),
      _c("category-manager", {
        ref: "CategoryManager",
        attrs: { categories: _vm.initialCategories },
        on: { update: _vm.handleCategoriesUpdate },
      }),
      _c("pop-process", { ref: "popProcess" }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "接收人员", multiple: true },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("数据列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }